





























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'side-nav-item'
})
export default class SideNavItem extends Vue {
  @Prop({ required: true })
  private title!: string;

  @Prop()
  private icon!: string;

  @Prop({ default: 'fal' })
  private iconStyle!: string;

  @Prop()
  private href!: string;

  @Prop({ required: true })
  private route!: string;

  @Prop({ default: false })
  private collapsible!: boolean;

  @Prop({ default: false })
  private showCollapsible!: boolean;

  @Prop({ default: false })
  private alwaysOpen!: boolean;

  private show: boolean = this.showCollapsible;

  onClick() {
    this.show = this.alwaysOpen ? true : !this.show;
  }
}
